export const koKR_notice = {
  'app.notice.messages': `메시지`,
  'app.notice.news': `소식`,
  'app.notice.tasks': `작업`
};
